import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-comdetordcom',
  templateUrl: './comdetordcom.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class ComdetordcomComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
